import { render, staticRenderFns } from "./LocationSettings.vue?vue&type=template&id=7d80579c&scoped=true"
import script from "./LocationSettings.vue?vue&type=script&lang=js"
export * from "./LocationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d80579c",
  null
  
)

export default component.exports